module.exports = __webpack_public_path__ + "13.png?2d3dab8a6c040da911ad7c9b4a7d1ad0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshots/13.png
// module id = 127
// module chunks = 3